/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Tag, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import RopaService from '../../../../services/Ropa.service';
import ModalPersonalData from '../../../data-flow/components/DataflowDetail/components/ModalPersonalData';
import ModalSensitiveData from '../../../data-flow/components/DataflowDetail/components/ModalSensitiveData';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const Tab5 = (isNoPermission, detailInfo) => {
    const { t, i18n } = useTranslation();
    const { activityId } = useParams();
    const lang = i18n.language;
    const [openPersonalDataModal, setOpenPersonalDataModal] = useState(false);
    const [openSensitiveDataModal, setOpenSensitiveDataModal] = useState(false);
    const [personalData, setPersonalData] = useState([]);
    const [sensitiveData, setSensitiveData] = useState([]);
    const [databaseData, setDatabaseData] = useState();
    const [data, setDatabase] = useState([]);

    useEffect(() => {
        const getDataBase = async () => {
            try {
                const { data } = await RopaService.getDataBase(activityId);
                if (data?.resultData) {
                    const item = data?.resultData;
                    setDatabaseData(item);
                    setDatabase(item?.database);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getDataBase();
    }, []);

    const columns = [
        {
            title: <div>{t('RoPA.Database')}</div>,
            dataIndex: 'databaseName',
            key: 'databaseName',
            width: '24%',
            render: (text) => (
                <span className="text-gray-500 font-semibold">{text}</span>
            ),
        },
        {
            title: <div>{t('RoPA.personalData')}</div>,
            dataIndex: 'personalData',
            key: 'personalData',
            width: '29%',
            render: (_, { personalData }) => (
                <>
                    {personalData?.length > 0 ? (
                        personalData.map((item, index) => {
                            if (index < 4) {
                                return (
                                    <Tag
                                        className="mb-1"
                                        style={{
                                            backgroundColor: '#DFF3FC',
                                            color: '#1890FF',
                                            border: '0px',
                                            borderRadius: '17px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '150px',
                                            }}
                                        >
                                            <Tooltip
                                                className="cursor-pointer"
                                                placement="topLeft"
                                                title={<>{item.name}</>}
                                            >
                                                {item.name}
                                            </Tooltip>
                                        </div>
                                    </Tag>
                                );
                            }
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                    {personalData?.length > 4 && (
                        <Tag
                            className="cursor-pointer"
                            style={{
                                backgroundColor: '#B2B2B2',
                                color: '#FFFFFF',
                                border: '0px',
                                borderRadius: '17px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                maxWidth: '150px',
                            }}
                            onClick={() => {
                                setPersonalData(personalData);
                                setOpenPersonalDataModal(true);
                            }}
                        >
                            +{personalData?.length - 4}
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: <div>{t('RoPA.sensitivePersonalDataOption')}</div>,
            dataIndex: 'sensitiveData',
            key: 'sensitiveData',
            width: '29%',
            render: (_, { sensitiveData }) => (
                <>
                    {sensitiveData?.length > 0 ? (
                        sensitiveData.map((item, index) => {
                            if (index < 4) {
                                return (
                                    <Tag
                                        className="mb-1"
                                        style={{
                                            backgroundColor: '#FFF7E6',
                                            color: '#FF6E04',
                                            border: '0px',
                                            borderRadius: '17px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '150px',
                                            }}
                                        >
                                            <Tooltip
                                                className="cursor-pointer"
                                                placement="topLeft"
                                                title={<>{item.name}</>}
                                            >
                                                {item.name}
                                            </Tooltip>
                                        </div>
                                    </Tag>
                                );
                            }
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                    {sensitiveData?.length > 4 && (
                        <Tag
                            className="cursor-pointer"
                            style={{
                                backgroundColor: '#B2B2B2',
                                color: '#FFFFFF',
                                border: '0px',
                                borderRadius: '17px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                maxWidth: '150px',
                            }}
                            onClick={() => {
                                setSensitiveData(sensitiveData);
                                setOpenSensitiveDataModal(true);
                            }}
                        >
                            +{sensitiveData?.length - 4}
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: <div>{t('dataFlow.StoragePeriod')}</div>,
            dataIndex: 'period',
            key: 'period',
            width: '18%',
        },
    ];

    return (
        <div className="grid grid-cols-3">
            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('Department')}
                </div>
                <p className="mb-0">
                    {databaseData?.departmentNameEn ||
                    databaseData?.departmentNameTh ? (
                        <>
                            {lang === 'en'
                                ? databaseData?.departmentNameEn
                                : databaseData?.departmentNameTh}
                        </>
                    ) : (
                        '-'
                    )}
                </p>
            </div>
            <div className="col-span-3 bg-white rounded-xl">
                <Table
                    // bordered
                    rowKey={(record) => record.datahubDbDetailId}
                    className="inbox_table"
                    dataSource={data}
                    columns={columns}
                    pagination={false}
                    scroll={{ y: 880 }}
                />
            </div>

            <ModalPersonalData
                open={openPersonalDataModal}
                handelClose={() => setOpenPersonalDataModal(false)}
                personalData={personalData}
            />

            <ModalSensitiveData
                open={openSensitiveDataModal}
                handelClose={() => setOpenSensitiveDataModal(false)}
                sensitiveData={sensitiveData}
            />
        </div>
    );
};
export default Tab5;
